import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

// Custom Component
import RFIDraftResponseItem from "./RFIDraftReponseItem";

// Custom Style
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));

const RFIDraftResponse = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  // Use redux data

  const {
    rfi_seq,
    saveDraftResponsetoDraftAction,
    postDraftResponseConfirmAction,
    submissionValue,
    setSubmissionValue,
    draftResponseFileUploadAction,
    removeDraftResponseFileConfirmAction,
    viewFileAction,
    openDraftFileManagerDialog,
    draftfileManagerDialogHandleOpen,
    openFileManagerDialog,
    presetDraftResponseFiles,
    tmpResponseSeq,
    setTmpResponseSeq,
  } = props;

  useEffect(() => {
    let data = { ...submissionValue };
    data.draftMessages = submissionValue.draftResponses;
    data.draftResponses = [];
    setSubmissionValue({ ...submissionValue, ...data });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });
  }, []);

  return (
    <Fragment>
      <Grid item xs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Typography variant="subtitle1" className={classes.headerText}>
            Draft of Response
          </Typography>
          <Divider className={classes.divider} />

          {submissionValue.draftMessages &&
          submissionValue.draftMessages.length > 0 ? (
            submissionValue.draftMessages.map((obj, index) => {
              return (
                <div key={index}>
                  <RFIDraftResponseItem
                    rfi_seq={rfi_seq}
                    saveDraftResponsetoDraftAction={
                      saveDraftResponsetoDraftAction
                    }
                    postDraftResponseConfirmAction={
                      postDraftResponseConfirmAction
                    }
                    submissionValue={submissionValue}
                    setSubmissionValue={setSubmissionValue}
                    draftResponseFileUploadAction={
                      draftResponseFileUploadAction
                    }
                    removeDraftResponseFileConfirmAction={
                      removeDraftResponseFileConfirmAction
                    }
                    viewFileAction={viewFileAction}
                    openDraftFileManagerDialog={openDraftFileManagerDialog}
                    draftfileManagerDialogHandleOpen={
                      draftfileManagerDialogHandleOpen
                    }
                    openFileManagerDialog={openFileManagerDialog}
                    presetDraftResponseFiles={presetDraftResponseFiles}
                    index={index}
                    obj={obj}
                    response_seq={obj.response_seq}
                    tmpResponseSeq={tmpResponseSeq}
                    setTmpResponseSeq={setTmpResponseSeq}
                  />
                </div>
              );
            })
          ) : (
            <h3 style={{ color: "red" }}>No Draft Response</h3>
          )}
        </Box>
      </Grid>
    </Fragment>
  );
};

export default RFIDraftResponse;
